import * as React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "@/services/AuthService";

// Site-ID allowlist mirrors DeployLogsController._allowedSiteIds — update both together.
const SUPPORT_SITE_IDS = new Set([1032, 100050, 100060]);

/**
 * SupportAdminRoute — gates a route to Velaro staff identities.
 *
 * Passes for:
 *   1. Users on a Velaro-controlled site (1032, 100050, 100060)
 *   2. Users whose UserSite.IsVelaroSupport = true (stamped into JWT + profile at login)
 *
 * Use this for operational/diagnostic tools (Velaro Logger, Deploy History) that
 * support staff need without full billing/financial access.
 *
 * For routes that expose financial data (Billing, Stripe, QuickBooks) keep using
 * VelaroAdminRoute which only passes for siteId == 1032.
 */
export function SupportAdminRoute({ children }: { children: React.ReactNode }) {
  const profile = AuthService.profile;
  const isStaffSite = SUPPORT_SITE_IDS.has(profile?.siteId);
  const isVelaroSupport = profile?.isVelaroSupport === true;

  if (!isStaffSite && !isVelaroSupport) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

export default SupportAdminRoute;
